import { Link } from "react-router-dom";
import {
  ChevronRight,
  Image as ImageIcon,
  Pencil,
  Smile,
  Sparkles,
  Briefcase,
  Palette,
  Type,
  Zap,
} from "lucide-react";

const ICONS = {
  ImageIcon,
  Pencil,
  Smile,
  Sparkles,
  Briefcase,
  Palette,
  Type,
  Zap,
};

export const ToolCard = ({ tool, index = 0 }) => {
  const Icon = ICONS[tool.icon] || Sparkles;
  const tilt = ["tilt-1", "tilt-2", "tilt-3", "tilt-4"][index % 4];

  return (
    <Link
      to={tool.path}
      data-testid={`tool-card-${tool.id}`}
      className={`card-tilt block bg-white border-4 border-[#1a1a1a] rounded-3xl shadow-hard-md p-7 sm:p-8 relative overflow-hidden ${tilt}`}
    >
      {tool.isNew && (
        <div
          data-testid={`tool-card-${tool.id}-new-badge`}
          className="absolute -top-3 -right-3 bg-[#1a1a1a] text-[#22c55e] font-display font-black text-sm uppercase px-4 py-1 rounded-full border-4 border-[#1a1a1a] rotate-12"
        >
          ✦ Nuevo
        </div>
      )}
      <div
        className="w-16 h-16 rounded-2xl border-4 border-[#1a1a1a] flex items-center justify-center mb-6 shadow-hard-sm"
        style={{ background: tool.color }}
      >
        <Icon className="w-8 h-8 text-[#1a1a1a]" strokeWidth={3} />
      </div>
      <h3 className="font-display font-black text-2xl sm:text-3xl mb-2 tracking-tight">{tool.title}</h3>
      <p className="font-mono text-sm sm:text-base text-[#4a4a4a] leading-relaxed mb-8">{tool.tagline}</p>
      <div className="flex items-center justify-between">
        <span className="font-mono text-xs uppercase tracking-[0.2em] font-bold">Ir a la herramienta</span>
        <span
          className="w-10 h-10 rounded-xl border-4 border-[#1a1a1a] flex items-center justify-center"
          style={{ background: tool.color }}
        >
          <ChevronRight className="w-5 h-5 text-[#1a1a1a]" strokeWidth={3} />
        </span>
      </div>
    </Link>
  );
};

export default ToolCard;
